import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiBills, ApiContracts, ApiLeasingOffers } from 'modules/api';
import { PagingParams } from 'modules/types/PagingParams';
import { LeasingOfferStatus } from '../../../types/LeasingOffer';

export const fetchSearchResults = createAsyncThunk(
  'auth/getSearchResults',
  async (params: PagingParams, { rejectWithValue }) => {
    try {
      const [{ contracts }, { leasingOffers }, { bills }] = await Promise.all([
        ApiContracts.getActiveContracts({
          search: params.search,
        }),
        ApiLeasingOffers.getLeasingOffers({
          search: params.search,
          leasingOfferStatus: LeasingOfferStatus.ACTIVE,
        }),
        ApiBills.getBills({
          search: params.search,
        }),
      ]);
      return {
        contractsResults: contracts,
        offersResults: leasingOffers,
        billsResults: bills,
      };
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
